<template>
  <div class="row">
    <div class="col-4 offset-4 mt-5">
      <h2>Generování čárových kódů</h2>
      <div class="row my-3">
        <div class="col-lg-2">
          <label for="gender">Počet:</label>
        </div>
        <div class="col-lg-10">
          <b-form-input
            class="myInput"
            :type="'number'"
            v-model="amount" />
        </div>
        <div class="col-4 offset-4 mt-2">
          <b-button
            type="submit"
            class="myButton align-middle"
            @click="download()">
            Generovat
          </b-button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { downloadBlob } from '@utils/downloadBlob';

export default {
  data() {
    return {
      amount: 1
    };
  },
  methods: {
    download() {
      this.axios.get('admin/barcodes/generate', { params: {
        Amount: this.amount
      },
      responseType: 'arraybuffer' }).then((response) => {
        downloadBlob(response.data, 'Čárové kódy.pdf', 'application/pdf');
        this.$refs.downloadModal.hide();
      });
    }
  }
};
</script>
<style lang="scss" scoped>
@import '@colors';
.downloadBtn {
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12), 0 1px 2px rgba(0, 0, 0, 0.24);
  transition: all 0.3s cubic-bezier(0.25, 0.8, 0.25, 1);
  background-color: #c95328;
  color: $text-on-secondary;
  border: none;
  &:hover {
    box-shadow: 0 14px 28px rgba(0, 0, 0, 0.25), 0 10px 10px rgba(0, 0, 0, 0.22);
    background-color: darken($secondary-variant-color, 10%);
    color: $text-on-secondary;
  }
}
</style>
